<template>
    <div class="col-sm-12">
        <div class="card">
            <div class="card-header">
                <h3>Sizing Tables</h3><span>Example of Extra large table, Add <code>.table-xl</code> class to the
                    <code>.table</code> , Large table Add <code>.table-lg</code> , Default table Add <code>.table-de</code>
                    , Small table Add <code>.table-sm </code> , Extra Small table Add <code>.table-xs</code> to create a
                    table. "</span>
            </div>
            <div class="table-responsive">
                <table class="table table-lg">
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Employee Name</th>
                            <th>Date</th>
                            <th>Status</th>
                            <th>Hours</th>
                            <th>Performance</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in bootstraplist" :key="item">
                            <th scope="row">{{ item.id }}</th>
                            <td>{{ item.Name }}</td>
                            <td>{{ item.Date }}</td>
                            <td :class="item.statusClass">{{ item.Status }}</td>
                            <td>{{ item.hours }}</td>
                            <td>{{ item.performance }}</td>
                        </tr>

                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="col-sm-12">
        <div class="card">
            <div class="card-header">
                <h3>Custom Table Color with Hover and Stripped</h3><span>Use
                    class<code>table-hover, table-striped table-*</code><code>table-info</code>,<code>table-success</code>,<code>table-success</code>,<code>table-info</code>,<code>table-danger</code>,<code>table-primary</code>,<code>table-secondary</code>,<code>table-light</code>,<code>table-active</code>
                    inside table element.</span>
            </div>
            <div class="card-block row">
                <div class="col-sm-12 col-lg-12 col-xl-12">
                    <div class="table-responsive table-border-radius">
                        <table class="table table-striped bg-primary table-hover">
                            <thead>
                                <tr>
                                    <th scope="col">Id</th>
                                    <th scope="col">Film Title</th>
                                    <th scope="col">Released</th>
                                    <th scope="col">Studio</th>
                                    <th scope="col">Budget</th>
                                    <th scope="col">Domestic Gross</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="data in bootstrap" :key="data">
                                    <th scope="row">{{ data.id }}</th>
                                    <td>{{ data.film }}</td>
                                    <td>{{ data.released }}</td>
                                    <td>{{ data.studio }}</td>
                                    <td>{{ data.budget }}</td>
                                    <td>{{ data.domestic }}</td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
    computed: {
        ...mapState({
            bootstraplist: state => state.bootstrap.sizingTablesXl,
            bootstrap: state => state.bootstrap.tableData2,
        })
    },

}
</script>
